export default __webpack_public_path__ + "static/media/Harlot's Crossbow.6e8ee1e1.jpg";